import {Injectable} from '@angular/core';
import moment from "moment-timezone";
import {HarbourDuesDeclaration} from '@portbase/bezoekschip-service-typescriptmodels';

@Injectable({
  providedIn: 'root'
})
export class HarbourDuesUtilsService {

  invoicePeriod(start: string, end: string) {
    let invoiceStart = moment(start).format('D MMM');
    let invoiceEnd = end ? moment(end).format('D MMM') : 'now';
    if (invoiceStart === invoiceEnd) {
      return invoiceStart;
    }
    return `${invoiceStart} - ${invoiceEnd}`.toLowerCase();
  }

  mergeDeclarationAndFormData(
    declaration: HarbourDuesDeclaration,
    formValue: any
  ): HarbourDuesDeclaration {
    const mergedBerthVisits = declaration.visit?.berthVisits?.map((element, index) => {
      const formBerthVisitValue = formValue.berthVisits?.at(index) || {};
      return {...element, ...formBerthVisitValue};
    });

    return {
      ...declaration,
      discount: formValue.discount,
      exemption: formValue.exemption,
      specialTariff: formValue.specialTariff,
      incidentals: formValue.incidentals ?? [],
      visit: {
        ...declaration.visit,
        berthVisits: mergedBerthVisits
      }
    }
  }
}
